import {
  getLocalEmail as getLocalEmailFromRedux,
  getLocalName as getLocalNameFromRedux
} from '@selectors/auth';
import useLoginStore from '@stores/login/loginStore';
import { getLocalEmail, getLocalName } from '@stores/selectors/login';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useLocalEmailAndName = () => {
  const localEmailAddress = useLoginStore(getLocalEmail);
  const localName = useLoginStore(getLocalName);
  const localEmailAddressFromRedux = useSelector(getLocalEmailFromRedux);
  const localNameFromRedux = useSelector(getLocalNameFromRedux);
  return useMemo(() => {
    if (localEmailAddressFromRedux || localNameFromRedux)
      return {
        localEmailAddress: localEmailAddressFromRedux,
        localName: localNameFromRedux
      };

    if (localName || localEmailAddress)
      return {
        localEmailAddress,
        localName
      };

    return { localEmailAddress: '', localName: '' };
  }, [
    localEmailAddress,
    localName,
    localEmailAddressFromRedux,
    localNameFromRedux
  ]);
};

export default useLocalEmailAndName;
